import { BarChartScalesConfig, MetricDatum } from '../../../types';
import {
  formatNumber,
  calculateYAxisWidth,
  calculateXAxisLabelSpacing,
  CHAR_WIDTH_PX,
  MINIMUM_TICK_WIDTH_STRAIGHT,
  X_AXIS_LABEL_ANGLE_STRAIGHT,
} from '../../../utils/chartUtils';

type HistogramOptions = {
  data: MetricDatum[];
  scales?: BarChartScalesConfig;
  xAxisKeys: string[];
  yAxisKeys: string[];
  yAxisLabels: string[];
};

export const useHistogram = ({ data, scales, xAxisKeys, yAxisKeys, yAxisLabels }: HistogramOptions) => {
  if (!yAxisKeys || !xAxisKeys) {
    return {
      data,
      formatValue: () => '',
      xAxisKeys,
      xAxisLabelSpacing: () => 0,
      yAxisKeys,
      yAxisLabels,
      yAxisWidth: 0,
    };
  }

  const formatValue = (value: any) =>
    formatNumber({
      value,
      format: scales?.y?.tickFormat,
    });
  const yAxisWidth = calculateYAxisWidth(data, yAxisKeys, formatValue, CHAR_WIDTH_PX, MINIMUM_TICK_WIDTH_STRAIGHT);
  const xAxisLabelSpacing = (key: string | number) =>
    calculateXAxisLabelSpacing(data, key, CHAR_WIDTH_PX, X_AXIS_LABEL_ANGLE_STRAIGHT);

  return {
    data,
    formatValue,
    xAxisKeys,
    xAxisLabelSpacing,
    yAxisKeys,
    yAxisLabels,
    yAxisWidth,
  };
};
